import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 0.5rem;
  background-color: #EFE5C1;
  overflow: hidden;
  pointer-events: all;
`
export default Container;
